// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"4209dd34","368":"5ae83005","642":"7dbdd7ba","940":"5ae83005"}[chunkId] + ".chunk.css";
};